import React, { useEffect, useState } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import Link from '@nubank/nuds-web/components/Link/Link';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import { useBreakpointsMediaUp } from '@nubank/nuds-web/styles/breakpoints';

import { StyledLink } from './StyledLink';
import { StyledTypography } from './StyledTypography';
import CardsBoxDesktop from './CardsBoxDesktop';
import { cardsInfo } from './cardsInfo';

const StyledBox = styled(Box)`
  width: 100%;

  .splide {
    width: 100%;
  }

  /* When both cards fit, center the track instead of leaving empty space on the right */
  .splide:not(.is-overflow) .splide__list {
    justify-content: center;
  }

  .splide__pagination {
    display: flex;
    justify-content: left;
    padding-top: 24px;
    padding-left: 32px;
  }

  .splide:not(.is-overflow) .splide__pagination {
    justify-content: center;
    padding-left: 0;
  }

  .splide__pagination__page {
    border-radius: 12px;
    width: 8px;
    height: 8px;
    margin-right: 8px;
    background-color: ${nuDSColor('black.defaultT20')};

    &.is-active {
      width: 16px;
      background-color: ${nuDSColor('primary')};
    }
  }
`;

function MobileCardsCarousel() {
  return (
    <StyledBox
      paddingLeft={{ xs: '0', md: '12x' }}
      marginVertical={{ xs: '12x', md: '18x', lg: '24x' }}
      tag="section"
      display="flex"
      justifyContent="center"
      overflow="hidden"
    >
      <Splide
        aria-label="cards-carousel"
        options={{
          arrows: false,
          padding: { left: '32px', right: '23%' },
          gap: '32px',
          autoWidth: true,
          mediaQuery: 'min',
          breakpoints: {
            400: { padding: { right: '33%' } },
            520: { padding: 0 },
          },
        }}
      >

        {cardsInfo.map(card => (
          <SplideSlide key={card.id}>
            <Link href={card.href} noStyle>
              <Image
                srcSet={{ xs: card.image }}
                webp
                alt={card.alt}
                width={card.imageWidth || '100%'}
                height={card.imageHeight || 'auto'}
                loading="lazy"
              />

              <StyledTypography
                gradient={card.gradient}
                marginVertical="8x"
                variant="heading1"
                whiteSpace="pre-line"
              >
                {card.name}
              </StyledTypography>
            </Link>

            <StyledLink
              variant="action"
              href={card.href}
              width="fit-content"
              color="primary"
              typographyProps={{ color: card.color }}
              marginBottom={{ xs: '2x', lg: '0x' }}
              iconProps={{ name: 'arrow-up-right' }}
              gradient={card.gradient}
            >
              Conoce más
            </StyledLink>
          </SplideSlide>
        ))}
      </Splide>

    </StyledBox>
  );
}

function CardsCarousel() {
  const isDesktop = useBreakpointsMediaUp('md');
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return (
      <Box
        tag="section"
        minHeight={{ xs: '520px', md: '560px' }}
        aria-hidden="true"
      />
    );
  }

  return isDesktop ? <CardsBoxDesktop /> : <MobileCardsCarousel />;
}

export default CardsCarousel;
